// import { styled } from '@mui/material/styles';
import { styled } from "@mui/material/styles";
import { Box, Button, Typography, Chip, IconButton } from "@mui/material";
import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
* {
    font-family: Inter, sans-serif !important;
  }
`;
export const NoPlansContainer = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 48px 16px;
`;

export const NoPlansText = styled("div")`
  font-size: 1.5rem;
  color: #2372b9;
  font-weight: 400;
  text-align: center;
  font-family: "BentonSans", sans-serif !important;
`;

export const ChangeZipButton = styled(Button)`
  background-color: #2372b9;
  &:hover {
    background-color: #1d5a94;
  }
`;
// App Component Styles
export const AppWrapper = styled(Box)`
  min-height: 100vh;
  // background-color: #f5f5f5;
`;

export const LoadingOverlay = styled(Box)<{ isLoading: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  opacity: ${(props) => (props.isLoading ? 1 : 0)};
  visibility: ${(props) => (props.isLoading ? "visible" : "hidden")};
  transition:
    opacity 0.5s ease-out,
    visibility 0.5s ease-out;
`;

export const LoadingSpinner = styled(Box)`
  width: 60px;
  height: 60px;
  border: 4px solid #e0e0e0;
  border-top: 4px solid #2372b9;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const LoadingText = styled(Typography)`
  color: #2372b9;
  font-size: 16px;
  font-weight: 500;
  font-family: "Inter", sans-serif;
`;

// Header Component Styles
export const HeaderWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isSticky",
})<{ isSticky?: boolean }>`
  display: flex;
  width: 100%;
  padding: 11px 16px;
  justify-content: space-between;
  align-items: center;
  position: ${(props) => (props.isSticky ? "fixed" : "absolute")};
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: ${(props) => (props.isSticky ? "#ffffff" : "transparent")};
  color: ${(props) => (props.isSticky ? "inherit" : "#2372b9")};
  box-shadow: ${(props) =>
    props.isSticky ? "0 2px 8px rgba(0, 0, 0, 0.1)" : "none"};
  transition: all 0.3s ease-in-out;

  @media (min-width: 900px) {
    padding: 11px 80px;
  }

  @media (min-width: 1200px) {
    padding: 11px 70px;
  }
`;

export const HeaderContainer = styled(Box)`
  display: flex;
  max-width: 1240px;
  justify-content: space-between;
  align-items: center;
  flex: 1 0 0;
`;

export const HeaderLogo = styled("img")`
  width: 120px;
  height: auto;

  @media (min-width: 768px) {
    width: 140px;
  }

  @media (min-width: 900px) {
    width: 162px;
    height: 27px;
  }
`;

export const HeaderActions = styled(Box)`
  display: flex;
  align-items: center;
  gap: 16px;

  @media (min-width: 768px) {
    gap: 20px;
  }

  @media (min-width: 900px) {
    gap: 24px;
  }
`;

export const HeaderCallButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "isSticky",
})<{ isSticky?: boolean }>`
  display: flex;
  padding: 6px 12px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 6px;
  border: 1px solid ${(props) => (props.isSticky ? "#2372B9" : "#fff")};
  color: ${(props) => (props.isSticky ? "#2372B9" : "#fff")};
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 22.5px;
  text-transform: none;
  cursor: pointer;
  background-color: transparent;
  transition: all 0.3s ease-in-out;

  &:hover {
    border: 1px solid #2372b9 !important;
    background-color: rgba(35, 114, 185, 0.1);
  }

  @media (min-width: 768px) {
    padding: 7px 14px;
  }

  @media (min-width: 900px) {
    padding: 8px 16px;
    background-color: transparent;
  }
`;

export const HeaderPhoneText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "isSticky",
})<{ isSticky?: boolean }>`
  color: ${(props) =>
    props.isSticky ? "#2372B9" : "rgba(255, 255, 255, 0.8)"};
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22.5px;
  display: none;
  transition: all 0.3s ease-in-out;

  @media (min-width: 768px) {
    display: block;
  }

  @media (min-width: 900px) {
    display: block;
  }
`;

// Hero Banner Component Styles
export const HeroBannerWrapper = styled(Box)`
  background: #2372b9;
  position: relative;
  overflow: hidden;
  width: 100%;
`;

export const HeroBannerContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 120px 0px 16px 0;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  max-width: 1440px;
  margin: 0 auto;
  position: relative;

  @media (min-width: 768px) {
    padding: 120px 48px 32px 48px;
  }

  @media (min-width: 900px) {
    padding: 120px 80px 48px 80px;
  }

  @media (min-width: 1200px) {
    padding: 120px 132px 64px 132px;
  }
`;

export const HeroBannerTitle = styled(Typography)`
  padding: 0 16px;
  max-width: 100%;
  flex: 1 0 0;
  color: #fff;
  font-family: Inter;
  font-size: 2rem;
  font-style: normal;
  font-weight: 300;
  line-height: 120%;
  letter-spacing: -0.8px;
  z-index: 2;
  font-family: "BentonSansBook", sans-serif !important;

  @media (min-width: 768px) {
    padding: 0;
    font-size: 48px;
    letter-spacing: -1px;
  }

  @media (min-width: 900px) {
    padding: 0;
    max-width: 900px;
    font-size: 52px;
    letter-spacing: -1.1px;
  }

  @media (min-width: 1200px) {
    max-width: 1200px;
    font-size: 64px;
    letter-spacing: -1.28px;
  }
`;

export const HeroBannerHighlight = styled("span")`
  color: #d9e949;
  font-family: "BentonSansBook", sans-serif !important;
`;

export const HeroBannerImage = styled("img")`
  object-fit: cover;
  width: auto;
  height: auto;
  position: relative;
  right: auto;
  top: auto;
  display: none;
  z-index: 1;

  @media (min-width: 768px) {
    width: 600px;
    position: absolute;
    right: -180px;
    top: 20px;
    display: block;
  }

  @media (min-width: 900px) {
    width: 700px;
    right: -120px;
    top: 5px;
  }

  @media (min-width: 1200px) {
    width: 890px;
    right: -106px;
    top: -27px;
  }
`;

export const HeroBannerInputContainer = styled(Box)`
  display: flex;
  gap: 12px;
  align-items: center;
  z-index: 2;
  position: relative;
  max-width: 450px;
  width: 100%;
  padding: 0 16px;

  @media (min-width: 768px) {
    padding: 0;
    max-width: 500px;
  }

  @media (min-width: 900px) {
    padding: 0;
  }
`;

export const HeroBannerInput = styled("input")`
  flex: 1;
  padding: 14px 20px;
  font-size: 16px;
  font-family: "Inter", sans-serif;
  border: 2px solid #dde4ea;
  border-radius: 8px;
  outline: none;
  transition: all 0.3s ease;
  background: #fff;
  color: #364153;

  &::placeholder {
    color: #7f9097;
  }

  &:focus {
    border-color: #2372b9;
    box-shadow: 0 0 0 3px rgba(35, 114, 185, 0.1);
  }

  &:disabled {
    background: #f5f7fa;
    cursor: not-allowed;
  }
`;

export const HeroBannerSubmitButton = styled("button")`
  padding: 16px 32px;
  font-size: 16px;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  color: #fff;
  background: #1d5a94;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;

  &:hover:not(:disabled) {
    background: #1c4b77ff;
    box-shadow: 0 4px 12px rgba(16, 91, 156, 0.3);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    background: #b0bec5;
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

// Pricing Plans Component Styles
export const PricingPlansWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap:0;
  align-self: stretch;
  background: none;
  padding: 12px;

  @media (min-width: 768px) {
    padding: 48px 0 80px 0;
  }

  @media (min-width: 900px) {
    padding: 18px 0 20px 0;
  }

  @keyframes fadeInUp {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fadeOutDown {
    0% {
      opacity: 1;
      transform: translateY(0);
    }
    100% {
      opacity: 0;
      transform: translateY(20px);
    }
  }

  @keyframes slideDown {
    0% {
      max-height: 0;
      opacity: 0;
      transform: translateY(-20px);
    }
    100% {
      max-height: 2000px;
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes slideUp {
    0% {
      max-height: 2000px;
      opacity: 1;
      transform: translateY(0);
    }
    100% {
      max-height: 0;
      opacity: 0;
      transform: translateY(-20px);
    }
  }
`;

export const PricingFiltersContainer = styled(Box)`
  display: flex;
  padding: 0 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  flex-wrap: wrap;
  padding: 10px 16px;

  @media (min-width: 768px) {
    padding:16px;
  }

  @media (min-width: 900px) {
    padding: 0 80px;
  }

  @media (min-width: 1200px) {
    padding: 12px 120px;
  }
`;
export const PricingFiltersTitle = styled(Box)`
  padding: 0 16px;
  max-width: 100%;
  flex: 1 0 0;
  color: #2372b9;
  font-family: Inter;
  font-size: 2rem;
  font-style: normal;
  font-weight: 300;
  line-height: 120%;
  letter-spacing: -0.8px;
  z-index: 2;
  font-family: "BentonSansBook", sans-serif !important;

  @media (min-width: 768px) {
    padding: 0;
    font-size: 48px;
    letter-spacing: -1px;
  }

  @media (min-width: 900px) {
    padding: 0;
    max-width: 900px;
    font-size: 52px;
    letter-spacing: -1.1px;
  }

  @media (min-width: 1200px) {
    max-width: 1200px;
    font-size: 64px;
    letter-spacing: -1.28px;
  }
`;

export const PricingFiltersWrapper = styled(Box)`
  display: flex;
  max-width: 1200px;
  align-items: center;
  justify-content: center;
  gap: 16px;
  flex: 1 0 0;
`;

export const TabButtonGroup = styled(Box)`
  display: none;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #ebf1f6;
  background: #f9fafb;
  position: relative;

  @media (min-width: 768px) {
    display: flex;
  }

  @media (min-width: 900px) {
    display: flex;
  }
`;

export const TabButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "active",
})<{ active?: boolean }>`
  display: flex;
  padding: 8px 16px;
  justify-content: center;
  text-transform: none;
  border-radius: 8px;
  ba
  min-width: auto;
  color: ${({ active }) => (active ? "#fff" : "#364153")};
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.15px;
  background: ${({ active }) => (active ? "#2372b9" : "transparent")};
  transition: all 0.3s ease-in-out;
  z-index: 1;

  &:hover {
    background: ${({ active }) => (active ? "#1d5a94" : "rgba(35, 114, 185, 0.08)")};
  }
`;

export const FilterButton = styled(Button)`
  display: flex;
  height: 36px;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  text-transform: none;
  font-weight: 500;
  border-radius: 8px;
  color: #364153;
  background-color: #f9fafb;
  border: 1px solid #ebf1f6;
  cursor: pointer;

  &:hover {
    background-color: #f0f4f8;
    border-color: #2372b9;
  }
`;

export const ZipCodeInput = styled("input")`
  width: 100%;
  padding: 12px 16px;
  font-size: 16px;
  font-family: "Inter", sans-serif;
  border: 2px solid #dde4ea;
  border-radius: 8px;
  outline: none;
  transition: border-color 0.3s ease;

  &:focus {
    border-color: #2372b9;
  }

  &::placeholder {
    color: #9ca3af;
  }
`;

export const PricingCardsGrid = styled(Box)`
  display: grid;
  width: 100%;
  max-width: 1200px;
  align-items: flex-start;
  gap: 12px;
  grid-template-columns: 1fr;
  transition: all 0.3s ease-in-out;
  padding: 0 16px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    padding: 0 18px !important;
  }

  @media (min-width: 900px) {
    grid-template-columns: repeat(3, 1fr);
    padding: 0;
  }
  @media (max-width: 1200px) {
    padding: 0 16px;
  }
`;

export const AdditionalCardsContainer = styled(Box)<{
  isExpanding?: boolean;
  isCollapsing?: boolean;
}>`
  display: grid;
  width: 100%;
  max-width: 1200px;
  align-items: flex-start;
  gap: 12px;
  grid-template-columns: 1fr;
  padding: 0 16px;
  // overflow: hidden;
  animation: ${({ isExpanding, isCollapsing }) =>
    isExpanding
      ? "slideDown 0.5s ease-out forwards"
      : isCollapsing
        ? "slideUp 0.5s ease-in forwards"
        : "none"};

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    padding: 0 48px;
  }

  @media (min-width: 900px) {
    grid-template-columns: repeat(3, 1fr);
    padding: 0;
  }
`;

export const PricingCard = styled(Box, {
  shouldForwardProp: (prop) =>
    !["highlight", "hasTransform", "transformX", "transformY"].includes(
      prop as string,
    ),
})<{
  highlight?: boolean;
  hasTransform?: boolean;
  transformX?: number;
  transformY?: number;
}>`
  background: ${({ highlight }) =>
    highlight
      ? "linear-gradient(white, white) padding-box, linear-gradient(180deg, #4995d9 -1.61%, #ff8a39 45.81%, #97cc26 100%) border-box"
      : "white"};
  border: ${({ highlight }) =>
    highlight ? "3px solid transparent" : "2.3px solid #bdc3c9"};
  border-radius: 18px;
  position: relative;

  // height: 406px;
  transition:
    transform 0.1s ease-out,
    box-shadow 0.3s ease-out;
  transform-style: preserve-3d;
  pointer-events: auto;
  box-shadow: ${({ hasTransform }) =>
    hasTransform
      ? "0 12px 32px rgba(35, 114, 185, 0.15), 0 4px 12px rgba(0,0,0,0.08)"
      : "0 2px 8px rgba(0,0,0,0.04)"};
  transform: ${({ transformX = 0, transformY = 0, hasTransform }) =>
    `perspective(1000px) rotateX(${-transformY * 0.5}deg) rotateY(${transformX * 0.5}deg) translateZ(${hasTransform ? "10px" : "0"})`} !important;

  &::before {
    content: ${({ hasTransform }) => (hasTransform ? '""' : "none")};
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 18px;
    // background: ${({ transformX = 0, transformY = 0 }) =>
      `radial-gradient(circle at ${50 + transformX}% ${50 + transformY}%, rgba(35, 114, 185, 0.1), transparent 70%)`};
    pointer-events: none;
    z-index: 1;
  }

  @media (max-width: 899px) {
    order: ${({ highlight }) => (highlight ? -1 : 0)};
  }
`;

export const PricingCardInner = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 0 0;
  align-self: stretch;
  border-radius: 16px;
  background: #fff;
  position: relative;
  z-index: 2;
`;

export const PricingCardHeader = styled(Box)`
  display: flex;
  height: 54px;
  padding: 16px 16px 4px 16px;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: 40px;
  align-self: stretch;

  @media (min-width: 900px) {
    padding: 0px 24px 4px 24px;
  }
`;

export const PricingCardTitle = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;

export const PlanName = styled(Typography)`
  color: #2372b9;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.15px;
`;

export const BestValueBadge = styled(Box)`
  display: flex;
  padding: 4px 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 5px;
  background: #eaf3de;
`;

export const BestValueText = styled(Typography)`
  color: #2372b9;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.15px;

  @media (min-width: 900px) {
    font-size: 12px;
  }
`;

export const PricingCardBody = styled(Box)`
  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  flex: 1 0 0;
  align-self: stretch;

  @media (min-width: 900px) {
    padding: 0px 24px 24px 24px;
    gap: 14px;
  }
`;

export const PriceDisplay = styled(Box)`
  display: flex;
  align-items: flex-start;
  // align-items: baseline;
  align-self: stretch;
`;

export const PriceValue = styled(Typography)`
  color: #2372b9;
  text-align: center;
  font-family: Inter;
  font-size: 44px;
  font-style: normal;
  font-weight: 400;
  line-height: 48px;
  letter-spacing: 0.352px;
  font-family: "BentonSansMedium", sans-serif !important;

  @media (min-width: 900px) {
    font-size: 48px;
  }
`;

export const PriceUnit = styled(Typography)`
  color: #2372b9;
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  margin-bottom: 6px;
  line-height: 20px;
  letter-spacing: -0.15px;
  align-self: end;
`;

export const SignUpButton = styled(Button)`
  display: flex;
  padding: 16px 20px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 6px;
  background: #f47b27;
  color: #fff;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  text-transform: none;
  letter-spacing: -0.15px;
  box-shadow: none;
  width: 100%;

  &:hover {
    background: #e67a2f;
    box-shadow: none;
  }
`;

export const FeaturesContainer = styled(Box)`
  display: flex;
  height: auto;
  min-height: 100px;
  flex-direction: column;
  justify-content: start;
  align-self: stretch;

  @media (min-width: 900px) {
    height: auto;
  }
`;

export const FeatureItem = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const FeatureText = styled(Typography)`
  font-size: 14px;
  color: #2372b9;
  letter-spacing: -0.15px;
`;

export const ViewDetailsLink = styled(Typography)`
  color: #2372b9;
  font-size: 14px;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: #1d5a94;
  }
`;

export const SavingsContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 10px;
  flex: 1 0 0;
  align-self: stretch;
`;

export const SavingsBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== "highlight",
})<{ highlight?: boolean }>`
  display: flex;
  padding: 12px 16px 16px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  gap: 8px;
  min-height: 503px;
  align-self: stretch;
  border-radius: 10px;
  min-height: 80px;
  background-color: ${({ highlight }) => (highlight ? "#eaf3de" : "#fafafa")};
`;

export const SavingsLabel = styled(Typography)`
  color: #2372b9;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.15px;
`;

export const SavingsBottom = styled(Box)`
  display: flex;
  align-items: flex-end;
  align-self: stretch;
  justify-content: space-between;
`;

export const SavingsValue = styled(Typography)`
  color: #2372b9;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%;
  font-family: "BentonSansMedium", sans-serif !important;
`;

export const SeeComparisonLink = styled(Typography)`
  color: #2372b9;
  text-align: right;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: #1d5a94;
  }
`;

export const ViewAllPlansButton = styled(Button)`
  color: #2372b9;
  text-align: right;
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  text-decoration: underline;
  cursor: pointer;
  background: #f9fafb;
  padding: 8px 16px; 
  border-radius: 8px;
   border: 0.5px solid #dde4ea;

  &:hover {
    color: #1d5a94;
    // border: 0.5px solid #2372b9;
      text-decoration: underline;
      background: #f9fafb;
  }
`;

export const SecondaryCtaContainer = styled(Box)`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  align-self: stretch;
  justify-content: space-between;
  width: 100%;
`;

export const SecondarySignUpButton = styled(Button)`
  display: flex;
  padding: 6px 0px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 6px;
  background: #ffffff;
  color: #2372b9;
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;c
  // line-height: 20px;
  text-transform: none;
  letter-spacing: -0.15px;
  box-shadow: none;
  width: 100%;

  &:hover {
    background: #d9e6f4;
    box-shadow: none;
    text-decoration: underline;
  }
`;

// Comparison Section Styles
export const ComparisonWrapper = styled(Box)`
  display: flex;
  padding: 80px 16px;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  align-self: stretch;
  background-color: #ffffff;
  position: relative;
  z-index: 0;

  @media (min-width: 768px) {
    padding: 80px 48px;
    gap: 48px;
  }

  @media (min-width: 900px) {
    padding: 0px 48px 60px 48px;
    gap: 52px;
  }

  @media (min-width: 1200px) {
    padding: 10px 0 80px 0;
    gap: 60px;
  }

  @keyframes grow {
    0% {
      width: 0%;
    }
    100% {
      width: var(--targetWidth);
    }
  }
`;

export const ComparisonHeaderContainer = styled(Box)`
  display: flex;
  width: 100%;
  max-width: 800px;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;

  @media (min-width: 900px) {
    max-width: 1200px;
    gap: 10px;
  }
`;

export const ComparisonTitle = styled(Box)`
  display: flex;
  max-width: 800px;
  align-items: flex-end;
  gap: 0;

  @media (min-width: 900px) {
    max-width: 755px;
  }
`;

export const ComparisonTitleText = styled(Typography)`
  color: #2372b9;
  font-size: 34px;
  font-style: normal;
  font-weight: 300;
  line-height: 120%;
  letter-spacing: -0.68px;
  font-family: "BentonSansBook", sans-serif !important;

  @media (min-width: 768px) {
    font-size: 44px;
    letter-spacing: -0.88px;
  }

  @media (min-width: 900px) {
    font-size: 56px;
    letter-spacing: -1.12px;
  }
`;

export const ComparisonArrow = styled("img")`
  width: 48px;
  height: 70px;
  aspect-ratio: 1/1;
  transform: rotate(45deg);

  @media (min-width: 900px) {
    width: 70px;
    transform: rotate(0deg);
  }
`;

export const ComparisonContent = styled(Box)`
  display: flex;
  width: 100%;
  max-width: 1200px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 32px;

  @media (min-width: 768px) {
    gap: 40px;
  }

  @media (min-width: 900px) {
    flex-direction: row;
    gap: 0px;
  }
`;

export const ComparisonLeftColumn = styled(Box)`
  display: flex;
  max-width: 100%;
  padding-right: 0;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;

  @media (min-width: 768px) {
    padding-right: 0;
  }

  @media (min-width: 900px) {
    max-width: 380px;
    padding-right: 40px;
  }

  @media (min-width: 1200px) {
    max-width: 480px;
    padding-right: 64px;
  }
`;

export const ComparisonDescription = styled(Typography)`
  color: #2372b9;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: -0.15px;

  @media (min-width: 900px) {
    font-size: 18px;
  }
`;

export const ComparisonSignUpButton = styled(Button)`
  display: flex;
  padding: 14px 18px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 6px;
  background-color: #e67a2f;
  color: #fff;
  text-transform: none;
  box-shadow: none;
  // align-self: stretch;
  margin-top: 8px;
    width: 100%;
  &:hover {
    background-color: #e67a2f;
    box-shadow: none;
  }

  @media (min-width: 900px) {
    padding: 16px 20px;
    align-self: flex-start;

  }
`;

export const ComparisonRightColumn = styled(Box)`
  min-width: 100%;
  max-width: 100%;
  gap: 20px;
  display: flex;
  flex-direction: column;
  flex: none;

  @media (min-width: 768px) {
    gap: 32px;
  }

  @media (min-width: 900px) {
    min-width: 500px;
    max-width: 600px;
    gap: 36px;
    flex: 1 0 0;
  }

  @media (min-width: 1200px) {
    min-width: 640px;
    max-width: 800px;
    gap: 42px;
  }
`;

export const ComparisonRow = styled(Box)`
  display: grid;
  grid-template-columns: 80px 1fr;
  align-items: center;
  gap: 16px;

  @media (min-width: 900px) {
    grid-template-columns: 120px 1fr;
    gap: 24px;
  }
`;

export const ComparisonLogo = styled("img")<{ grayscale?: boolean }>`
  width: 70px;
  height: auto;
  filter: ${({ grayscale }) => (grayscale ? "grayscale(100%)" : "none")};
  opacity: ${({ grayscale }) => (grayscale ? 0.5 : 1)};

  @media (min-width: 900px) {
    width: 120px;
  }
`;

export const ComparisonBarContainer = styled(Box)`
  position: relative;
  min-height: 69px;

  @media (min-width: 900px) {
    min-height: 50px;
  }
`;

export const ComparisonBar = styled(Box)<{
  color: string;
  delay: number;
  width: string;
}>`
  width: 0;
  height: 41px;
  background-color: ${({ color }) => color};
  animation: grow 1.2s ease-out forwards;
  animation-delay: ${({ delay }) => delay}s;
  --targetWidth: ${({ width }) => width};
`;

export const ComparisonDashedLine = styled(Box)`
  position: absolute;
  left: 0;
  right: 0;
  border-bottom: 1px dashed #2372b9;
  bottom: 28px;

  @media (min-width: 900px) {
    bottom: 9px;
  }
`;

export const ComparisonPriceText = styled(Typography)`
  position: absolute;
  right: 0;
  top: 4px;
  color: #2372b9;
  font-weight: 400;
  font-size: 16px;
  font-family: "BentonSansMedium", sans-serif !important;

  @media (min-width: 900px) {
    top: 6px;
    font-size: 24px;
  }
`;

export const ComparisonPriceUnit = styled("span")`
  font-weight: 500;
  font-size: 10px;
  margin-left: 4px;
  color: #2372b9;

  @media (min-width: 900px) {
    font-size: 12px;
  }
`;

export const ComparisonPlanName = styled(Box)`
  position: absolute;
  left: 0;
  color: #2372b9;
  font-size: 12px;
  font-weight: 600;
  padding-top: 8px;
  text-decoration: underline;

  @media (min-width: 900px) {
    font-size: 14px;
    padding-top: 8px;
  }
`;

export const ComparisonDisclaimer = styled(Typography)`
  margin-top: 40px;
  color: #7f9097;
  font-size: 0.7rem;
  line-height: 1.4;
  margin-left: 0;

  @media (min-width: 900px) {
    margin-top: 32px;
    font-size: 0.75rem;
    margin-left: 24px;
  }
`;

// Banner Section Styles
export const BannerSectionWrapper = styled(Box)`
  display: flex;
  padding: 40px 16px;
  justify-content: center;
  align-items: center;
  gap: 40px;
  align-self: stretch;
  background-color: #d9e949;

  @media (min-width: 768px) {
    padding: 48px 48px;
  }

  @media (min-width: 900px) {
    padding: 56px 80px;
  }

  @media (min-width: 1200px) {
    padding: 64px 120px;
  }
`;

export const BannerSectionContent = styled(Box)`
  display: flex;
  flex-direction: column;
  max-width: 1200px;
  align-items: flex-start;
  gap: 40px;
  flex: 1 0 0;

  @media (min-width: 900px) {
    flex-direction: row;
    align-items: flex-end;
  }
`;

export const BannerSectionText = styled(Typography)`
  color: #135088;
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  letter-spacing: -0.72px;
  flex: 1 0 0;
  font-family: "BentonSansBook", sans-serif !important;

  @media (min-width: 768px) {
    font-size: 28px;
  }

  @media (min-width: 900px) {
    font-size: 36px;
  }
`;

export const BannerSectionButton = styled(Button)`
  display: flex;
  padding: 16px 20px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 6px;
  background-color: #2372b9 !important;
  color: #fff;
  text-transform: none;
  box-shadow: none;

  &:hover {
    background-color: #1d5a94;
    box-shadow: none;
  }
`;

export const BannerButtonText = styled(Typography)`
  color: #fff;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.15px;
`;

// Why Choose Section Styles
export const WhyChooseWrapper = styled(Box)`
  display: flex;
  padding: 24px 16px;
  justify-content: center;
  align-items: flex-start;
  gap: 64px;
  align-self: stretch;
  background-color: #2372b9;
  color: #fff;

  @media (min-width: 768px) {
    padding: 80px 48px;
  }

  @media (min-width: 900px) {
    padding: 100px 80px;
  }

  @media (min-width: 1200px) {
    padding: 60px  120px;
  }
`;

export const WhyChooseGrid = styled(Box)`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  gap: 16px;
  max-width: 1200px;
  width: 100%;
  height: auto;

  @media (min-width: 900px) and (max-width: 1429px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  @media (min-width: 1430px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-template-rows: repeat(2, minmax(0, 1fr));
    gap: 32px;
    height: 684px;
  }
`;

export const WhyChooseTextSection = styled(Box)`
  display: flex;
  padding-right: 0;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  flex: 1 0 0;
  align-self: stretch;

  @media (min-width: 900px) and (max-width: 1429px) {
    padding-right: 0;
    gap: 48px;
  }

  @media (min-width: 1430px) {
    padding-right: 64px;
    gap: 64px;
    grid-row: 1 / span 1;
    grid-column: 1 / span 1;
  }
`;

export const WhyChooseTitle = styled(Typography)`
  color: #fff;
  font-family: Inter;
  font-size: 34px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  letter-spacing: -0.68px;
  font-family: "BentonSansBook", sans-serif !important;

  @media (min-width: 768px) {
    font-size: 44px;
    letter-spacing: -0.88px;
  }

  @media (min-width: 900px) {
    font-size: 56px;
    font-weight: 300;
    line-height: 67.2px;
    letter-spacing: -1.12px;
  }
`;

export const WhyChooseDescription = styled(Typography)`
  color: #fff;
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  letter-spacing: -0.15px;
  padding-bottom: 16px;
`;

export const WhyChooseImageSection = styled(Box)`
  display: flex;
  padding: 40px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  flex: 1 0 0;
  align-self: stretch;
  border-radius: 16px;
  background-image: url(/images/constenewImg/img-benefits-min.jpg);
  background-size: cover;
  background-position: 50%;
  background-repeat: no-repeat;
  background-color: lightgray;
  aspect-ratio: 343 / 191.47;

  @media (min-width: 900px) and (max-width: 1429px) {
    padding: 40px 32px;
    min-height: 300px;
  }

  @media (min-width: 1430px) {
    padding: 40px;
    grid-row: 2 / span 1;
    grid-column: 1 / span 1;
  }
`;

export const WhyChooseCardsTop = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  flex: 1 0 0;
  align-self: stretch;
  flex-wrap: nowrap;

  @media (min-width: 900px) and (max-width: 1429px) {
    flex-direction: row;
    gap: 24px;
    flex-wrap: wrap;
  }

  @media (min-width: 1430px) {
    flex-direction: row;
    gap: 32px;
    flex-wrap: wrap;
    grid-row: 1 / span 1;
    grid-column: 2 / span 1;
  }
`;

export const WhyChooseCardsBottom = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  flex: 1 0 0;
  align-self: stretch;
  flex-wrap: nowrap;

  @media (min-width: 900px) and (max-width: 1429px) {
    flex-direction: row;
    gap: 24px;
    flex-wrap: wrap;
  }

  @media (min-width: 1430px) {
    flex-direction: row;
    gap: 32px;
    flex-wrap: wrap;
    grid-row: 2 / span 1;
    grid-column: 2 / span 1;
  }
`;

export const WhyChooseCard = styled(Box)`
  display: flex;
  padding: 42px 16px 24px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  flex: 1 0 0;
  align-self: stretch;
  background-color: #1667b0;
  border-radius: 16px;

  @media (min-width: 900px) {
    padding: 32px 24px;
    gap: 24px;
  }
`;

export const WhyChooseCardContent = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 22px;
  align-self: stretch;
`;

export const WhyChooseCardIcon = styled("img")`
  width: 64px;
  height: auto;
  margin: 0 auto;
  display: block;
`;

export const WhyChooseCardTitle = styled(Typography)`
  color: #fff;
  text-align: center;
  font-family: Inter;
  font-size: 28px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  letter-spacing: -0.56px;
  font-family: "BentonSansBook", sans-serif !important;

  @media (min-width: 900px) {
    font-size: 36px;
    letter-spacing: -0.72px;
  }
`;

export const WhyChooseCardDescription = styled(Typography)`
  align-self: stretch;
  color: #fff;
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.15px;
`;

// Footer Styles
export const FooterWrapper = styled(Box)`
  display: flex;
  padding: 64px 16px;
  flex-direction: column;
  align-items: center;
  gap: 64px;
  align-self: stretch;
  background: linear-gradient(180deg, #2372b9 0%, #174a78 100%);

  @media (min-width: 768px) {
    padding: 64px 48px;
  }

  @media (min-width: 900px) {
    padding: 64px 80px;
  }

  @media (min-width: 1200px) {
    padding: 64px 120px;
  }
`;

export const FooterTopSection = styled(Box)`
  display: flex;
  width: 100%;
  max-width: 1200px;
  padding: 0;
  flex-direction: column;
  align-items: center;
  gap: 40px;

  @media (min-width: 900px) {
    padding: 0 24px;
  }
`;

export const FooterTopContent = styled(Box)`
  display: flex;
  width: 100%;
  max-width: 1152px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 40px;

  @media (min-width: 900px) {
    flex-direction: row;
    align-items: center;
    gap: 0;
  }
`;

export const FooterLeftSection = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1 0 0;
  flex-direction: column;
  gap: 32px;
  align-self: stretch;

  @media (min-width: 900px) {
    flex-direction: row;
    align-self: auto;
  }
`;

export const FooterLogoContainer = styled(Box)`
  display: flex;
  padding: 0;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;

  @media (min-width: 900px) {
    padding: 24px 0;
  }
`;

export const FooterLogo = styled("img")`
  width: 180px;
  height: auto;

  @media (min-width: 900px) {
    width: 243px;
  }
`;

export const FooterAwardSection = styled(Box)`
  display: flex;
  max-width: 100%;
  align-items: flex-start;
  flex: 1 0 0;
  flex-direction: column;
  gap: 16px;

  @media (min-width: 900px) {
    max-width: 640px;
    flex-direction: row;
    align-items: center;
    gap: 0;
  }
`;

export const FooterAwardText = styled(Typography)`
  color: #ebf1f6;
  font-family: Inter;
  font-size: 28px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  letter-spacing: -0.48px;
  font-family: "BentonSansBook", sans-serif !important;

  @media (min-width: 768px) {
    font-size: 32px;
    letter-spacing: -0.64px;
  }

  @media (min-width: 900px) {
    font-size: 26px;
    letter-spacing: -0.72px;
  }
`;

export const FooterAwardImage = styled("img")`
  width: 134px;
  height: auto;
`;

export const FooterDivider = styled(Box)`
  width: 100%;
  max-width: 1152px;
  height: 0;

  svg {
    width: 100%;
    height: 1px;
  }
`;

export const FooterBottomSection = styled(Box)`
  width: 100%;
  max-width: 1200px;
  height: auto;
  padding: 0 16px;

  @media (min-width: 768px) {
    padding: 0 24px;
  }

  @media (min-width: 900px) {
    height: 339px;
    padding: 0 24px;
  }
`;

export const FooterText = styled(Typography)`
  color: #dee9f4;
  font-family: Inter;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 15px;
  margin-bottom: 16px;

  @media (min-width: 900px) {
    line-height: 16.5px;
  }
`;

export const FooterTextSmall = styled(Typography)`
  color: #dee9f4;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 15px;
  margin-bottom: 16px;

  @media (min-width: 900px) {
    font-size: 11px;
    line-height: 16.5px;
  }
`;

export const FooterLink = styled("a")`
  color: #dee9f4;
  text-decoration: underline;

  &:hover {
    color: #fff;
  }
`;

export const FooterLinksSection = styled(Box)`
  width: 100%;
  max-width: 1200px;
  display: flex;
  justify-content: left;
  border-bottom: 1px solid rgba(222, 233, 244, 0.5);
  @media (max-width: 768px) {
    padding: 18px 0;
  }
  @media (min-width: 900px) {
    padding: 18px 0;
  }
`;

export const FooterLinksContainer = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 8px 16px;

  @media (min-width: 768px) {
    gap: 8px 16px;
  }
`;

export const FooterNavLink = styled("a")`
  color: #dee9f4;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  text-decoration: none;
  white-space: nowrap;
  transition: color 0.2s ease;

  &:hover {
    color: #fff;
    text-decoration: underline;
  }

  @media (min-width: 900px) {
    font-size: 13px;
  }
`;

export const FooterNavButton = styled("button")`
  color: #dee9f4 !important;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  text-decoration: none;
  white-space: nowrap;
  transition: color 0.2s ease;
  background: none !important;
  border: none !important;
  padding: 0 !important;
  cursor: pointer;
  outline: none;
  box-shadow: none !important;

  &:hover {
    color: #fff !important;
    text-decoration: underline;
  }

  &:focus {
    color: #dee9f4 !important;
    outline: none;
  }

  &:active {
    color: #dee9f4 !important;
  }

  @media (min-width: 900px) {
    font-size: 13px;
  }
`;

export const FooterLinkDivider = styled("span")`
  color: rgba(222, 233, 244, 0.5);
  font-size: 12px;
  display: none;

  @media (min-width: 900px) {
    display: inline;
    font-size: 13px;
  }
`;

// Plan Details Modal Styles
export const ModalBox = styled(Box)`
  background-color: white;
  border-radius: 16px;
  padding: 16px;
  max-width: 500px;
  width: 95%;
  max-height: 90vh;
  overflow: auto;
  outline: none;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  position: relative;
  animation: modalFadeIn 0.3s ease-out;

  @keyframes modalFadeIn {
    0% {
      opacity: 0;
      transform: scale(0.9) translateY(-20px);
    }
    100% {
      opacity: 1;
      transform: scale(1) translateY(0);
    }
  }

  @media (min-width: 900px) {
    padding: 32px;
    width: 90%;
  }
`;

export const ModalCloseButton = styled(IconButton)`
  position: absolute;
  top: 16px;
  right: 16px;
  color: #576367;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;

export const ModalHeader = styled(Box)`
  margin-bottom: 24px;
`;

export const ModalTitleRow = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  width: 90%;

  @media (min-width: 900px) {
    width: auto;
  }
`;

export const ModalPlanName = styled(Typography)`
  color: #2372b9;
  font-size: 14px;
  font-weight: 600;
`;

export const ModalBadge = styled(Chip)`
  background-color: #ebf1f6;
  color: #2372b9;
  font-size: 14px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 5px;
  @media (min-width: 900px) {
    padding: 4px 4px;
  }
`;

export const ModalPriceRow = styled(Box)`
  display: flex;
  align-items: flex-start;
  gap: 4px;
`;

export const ModalPriceValue = styled(Typography)`
  color: #2372b9;
  font-size: 48px;
  font-weight: 500;
  line-height: 48px;
`;

export const ModalPriceCent = styled(Typography)`
  color: #2372b9;
  font-size: 1.6rem;
  font-weight: 600;
  line-height: 1;
`;

export const ModalPriceUnit = styled(Typography)`
  color: #2372b9;
  font-size: 14px;
  margin-left: 8px;
  font-weight: 600;
  align-self: end;
`;

export const ModalFeaturesSection = styled(Box)`
  margin-bottom: 24px;
`;

export const ModalFeatureItem = styled(Box)`
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
  align-items: flex-start;
`;

export const ModalFeatureText = styled(Typography)`
  color: #2372b9;
  font-size: 0.95rem;
`;

export const ModalSignUpButton = styled(Button)`
  width: 100%;
  background-color: #ff8c42;
  color: white;
  text-transform: none;
  padding: 12px 0;
  font-size: 16px;
  font-weight: 600;
  border-radius: 6px;
  box-shadow: none;
  margin-bottom: 32px;

  &:hover {
    background-color: #e67a2f;
    box-shadow: none;
  }
`;

export const ModalPDFSection = styled(Box)`
  margin-bottom: 8px;
`;

export const ModalPDFButtons = styled(Box)`
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
`;

export const ModalPDFButton = styled(Button)`
  color: #2372b9;
  border-color: #2372b9;
  text-transform: none;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 6px;
  flex: 1;

  &:hover {
    border-color: #1d5a94;
    background-color: #2372b9;
    color: #fff;

    & svg {
      fill: #fff;
    }
  }
`;

export const ModalPDFDisclaimer = styled(Typography)`
  color: #2372b9;
  font-size: 12px;
`;

// Scroll Reveal Component Styles
export const ScrollRevealBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isVisible" && prop !== "delay",
})<{ isVisible: boolean; delay: number }>`
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  transform: ${({ isVisible }) =>
    isVisible ? "translateY(0) scale(1)" : "translateY(60px) scale(0.95)"};
  transition:
    opacity 0.9s ease-out ${({ delay }) => delay}s,
    transform 0.9s ease-out ${({ delay }) => delay}s;
`;

// ZipCodeBanner Styled Components
export const ZipBannerWrapper = styled(Box)`
  display: flex;
  padding: 80px 16px;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  background-color: #ffffff;

  @media (min-width: 768px) {
    padding: 80px 48px;
  }

  @media (min-width: 900px) {
    padding: 61px;
  }
`;

export const ZipBannerContent = styled(Box)`
  display: flex;
  width: 100%;
  max-width: 1200px;
  flex-direction: column-reverse;
  align-items: center;
  justify-content: center;
  gap: 40px;

  @media (min-width: 768px) {
    gap: 48px;
  }

  @media (min-width: 900px) {
    flex-direction: row;
    gap: 64px;
  }
`;

export const ZipBannerImageBox = styled(Box)`
  display: flex;
  max-width: 100%;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;
  @media (min-width: 900px) {
    max-width: 441px;
  }
`;

export const ZipBannerImage = styled("img")`
  width: 100%;
  height: auto;
  object-fit: contain;
`;

export const ZipBannerTextCol = styled(Box)`
  min-width: 100%;
  max-width: 100%;
  gap: 20px;
  display: flex;
  flex-direction: column;
  flex: none;
  @media (min-width: 900px) {
    min-width: 640px;
    max-width: 800px;
    gap: 32px;
    flex: 1 0 0;
  }
`;

export const ZipBannerTextGroup = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-self: stretch;
`;

export const ZipBannerSubText = styled(Typography)`
  color: #2372b9;
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: -0.15px;
  @media (min-width: 900px) {
    font-size: 18px;
  }
`;

export const ZipBannerHeadline = styled(Typography)`
  color: #2372b9;
  font-family: "BentonSansBook", sans-serif !important;
  font-size: 34px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  letter-spacing: -0.52px;

  @media (min-width: 768px) {
    font-size: 44px;
    letter-spacing: -0.88px;
  }

  @media (min-width: 900px) {
    font-size: 56px;
    letter-spacing: -1.12px;
  }
`;

export const ZipBannerButton = styled(Button)`
  display: flex;
  padding: 14px 18px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 6px;
  background-color: #f47b27;
  color: #fff;
  text-transform: none;
  box-shadow: none;
  align-self: flex-start;
  &:hover {
    background-color: #e67a2f;
    box-shadow: none;
  }
  @media (min-width: 900px) {
    padding: 16px 20px;
  }
`;

export const ZipBannerButtonIcon = styled(Box)`
  width: 20px;
  height: 20px;
`;

export const ZipBannerButtonText = styled(Typography)`
  color: #fff;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.15px;
  @media (min-width: 900px) {
    font-size: 16px;
  }
`;

export const BannerSectionWrapper2 = styled(Box)`
  width: 100%;
  height: auto;
`;
export const RibbionImage = styled("img")`
  width: 100%;
  height: auto;
  position: absolute;
  opacity: 0.6;
  top: 0px;

  @media (max-width: 900px) {
    top: 70px;
  }

    @media (max-width: 1200px) {
    top: 60px;
  }
`;

export const BannerSectionContainer2 = styled(Box)`
  width: 100%;
  display: flex;
  height: auto;
  padding : 24px 16px;
  flex-direction: column;
  justify-content: start;
  text-align: center;
  align-items: center;
 background: none !important;

  @media (min-width: 768px) {
 
  }

  @media (min-width: 900px) {
    // background-image: url("/images/newlandingpage/herobg.png");
    background-size: cover;
    background: none !important;
    background-repeat: no-repeat;
  }
`;

export const DiscoverPricingCardsGrid = styled(Box)`
  display: grid;
  width: 100%;
  max-width: 1200px;
  align-items: flex-start;
  gap: 24px;
  grid-template-columns: repeat(12, 1fr);
  transition: all 0.3s ease-in-out;
  padding: 0 16px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    padding: 0 18px !important;
  }

  @media (min-width: 900px) {
    grid-template-columns: repeat(3, 1fr);
    padding: 0;
  }
  @media (max-width: 1200px) {
    padding: 16 16px;
  }
`;

export const DiscoverAdditionalCardsContainer = styled(Box)<{
  isExpanding?: boolean;
  isCollapsing?: boolean;
}>`
  display: grid;
  width: 100%;
  max-width: 1200px;
  align-items: flex-start;
  gap: 24px;
  grid-template-columns: 1fr;
  padding: 0 16px;
  // overflow: hidden;
  animation: ${({ isExpanding, isCollapsing }) =>
    isExpanding
      ? "slideDown 0.5s ease-out forwards"
      : isCollapsing
        ? "slideUp 0.5s ease-in forwards"
        : "none"};

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    padding: 0 48px;
  }

  @media (min-width: 900px) {
    grid-template-columns: repeat(3, 1fr);
    padding: 0;
  }
`;

export const DiscoverPricingCard = styled(Box, {
  shouldForwardProp: (prop) =>
    !["highlight", "hasTransform", "transformX", "transformY"].includes(
      prop as string,
    ),
})<{
  highlight?: boolean;
  hasTransform?: boolean;
  transformX?: number;
  transformY?: number;
}>`
  background: ${({ highlight }) =>
    highlight
      ? "linear-gradient(white, white) padding-box, linear-gradient(180deg, #4995d9 -1.61%, #ff8a39 45.81%, #97cc26 100%) border-box"
      : "white"};
  border: ${({ highlight }) =>
    highlight ? "2.8px solid transparent" : "2.3px solid #bdc3c9"};
  border-radius: 18px;
  position: relative;
  // min-height: 280px;


  pointer-events: auto;

  &::before {
    content: ${({ hasTransform }) => (hasTransform ? '""' : "none")};
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 18px;
    // background: ${({ transformX = 0, transformY = 0 }) =>
      `radial-gradient(circle at ${50 + transformX}% ${50 + transformY}%, rgba(35, 114, 185, 0.1), transparent 70%)`};
    pointer-events: none;
    z-index: 1;
  }
     grid-column: span 12;
  @media (max-width: 899px) {
    order: ${({ highlight }) => (highlight ? -1 : 0)};
  }
      @media (min-width: 768px) {
    grid-column: span 6;
  }

  @media (min-width: 900px) {
    grid-column: span 4;
  }
`;
export const HeroBannerHighlightGreen = styled("span")`
  color: #6ba543;
  font-family: "BentonSansBook", sans-serif !important;
`;
